<div [innerHTML]="safeBody" (click)="onClick($event)"></div>
